export default "__VITE_ASSET__BMgSTPAy__"